<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Users/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>